import { assign, createMachine, sendParent } from 'xstate';
import { getFetchWrapper } from '@syf-api-library/core';
import accountSummary, { sendSummarySuccessToParent } from './accountSummary';
import alternatePaymentMethods, { sendAlternatePaymentMethodsSuccessToParent } from './alternatePaymentMethods';
import autopayStatus, { sendAutopayStatusSuccessToParent } from './autopayStatus';
import paymentEnterpriseEligibility, { sendEligibilitySuccessToParent } from './paymentEnterpriseEligibility';
import paymentMethods, { sendPaymentMethodsSuccessToParent } from './paymentMethods';
const BANK_NAME_URL = 'v1/credit/billing/payments/methods/bank';
const sendErrorToParent = sendParent((context, event) => {
    return Object.assign(Object.assign({}, event), { type: 'API_ERROR' });
});
const apiMachine = createMachine({
    id: 'apiMachine',
    predictableActionArguments: true,
    schema: { events: {} },
    type: 'parallel',
    states: {
        accountSummary,
        alternatePaymentMethods,
        autopayStatus,
        bankName: {
            initial: 'idle',
            states: {
                idle: {},
                loading: {
                    invoke: {
                        id: 'fetchBankName',
                        src: {
                            type: 'fetchBankName',
                            bankNameUrl: BANK_NAME_URL
                        },
                        onDone: {
                            target: 'resolved',
                            actions: assign({
                                bankNameQueryResult: (context, event) => {
                                    const { data } = event;
                                    return {
                                        data,
                                        error: undefined,
                                        isError: false
                                    };
                                }
                            })
                        },
                        onError: {
                            target: 'resolved',
                            actions: assign({
                                bankNameQueryResult: (context, event) => {
                                    const { data } = event;
                                    return {
                                        data: undefined,
                                        error: data,
                                        isError: true
                                    };
                                }
                            })
                        }
                    }
                },
                resolved: {
                    /*
                     * We're transitioning directly back to `idle` since bankNameQueryResult
                     * is an ephemeral state. This allows subscriptions to listen for the `resolve`
                     * transition, but also doesn't prematurely invoke with the next fetch request
                     */
                    after: {
                        0: {
                            target: 'idle',
                            actions: assign({
                                bankNameQueryResult: () => {
                                    return {
                                        data: undefined,
                                        error: undefined,
                                        isError: false
                                    };
                                }
                            })
                        }
                    }
                }
            },
            on: {
                FETCH_BANK_NAME: {
                    target: '.loading'
                }
            }
        },
        paymentEnterpriseEligibility,
        paymentMethods
    }
}, {
    actions: {
        sendSummarySuccessToParent,
        sendAlternatePaymentMethodsSuccessToParent,
        sendAutopayStatusSuccessToParent,
        sendEligibilitySuccessToParent,
        sendPaymentMethodsSuccessToParent,
        sendErrorToParent
    },
    services: {
        fetchBankName: async ({ apiConfig }, { routingNumber }, { src: { bankNameUrl } }) => {
            const fetchWrapper = getFetchWrapper(apiConfig.config);
            return fetchWrapper(`${bankNameUrl}/${routingNumber}`, {
                method: 'GET'
            });
        }
    }
});
export default apiMachine;
